import AzButton from '~/components/_next/atoms/AzButton.vue';
import { useGetTranslations } from '~/composables/useGetTranslations';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
export default defineComponent({
  name: 'ExpandButton',
  components: {
    AzButton: AzButton,
    AzIcon: AzIcon
  },
  props: {
    isExpanded: Boolean,
    title: {
      type: String,
      default: ''
    },
    collapseTitle: {
      type: String,
      default: ''
    },
    transparentBackground: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(props) {
    var _useGetTranslations = useGetTranslations(),
      translate = _useGetTranslations.translate;
    var translatedTitle = computed(function () {
      return props.title || translate('expandReadMore');
    });
    var translatedCollapseTitle = computed(function () {
      return props.collapseTitle || translate('collapseButtonText');
    });
    return {
      translatedTitle: translatedTitle,
      translatedCollapseTitle: translatedCollapseTitle
    };
  }
});